import * as api from '../api';
import { FETCH_ALL, CREATE, UPDATE, DELETE, SEARCH, START_LOADING, END_LOADING, FETCH_POST, COMMENT, FETCH_MORE, FETCH_SIMILAR, START_LOADING_SEARCH, END_LOADING_SEARCH, FETCH_USER_POSTS, FETCH_MORE_USER_POSTS, FETCH_PROFILE} from '../constants/actionTypes';

//searchPosts
export const searchPosts = (inputData, cb) => async (dispatch) => {

    let error = null; 
    let res = null;

    try {

        dispatch({
            type: START_LOADING_SEARCH
        });

        const {data: { data } } = await api.searchPosts(inputData);

        dispatch({
            type: SEARCH,
            payload: data
        });

        dispatch({
            type: END_LOADING_SEARCH
        });


        res = data; 


    } catch (err) {

        console.log(err);

        error = err
    }

    if(typeof cb === 'function'){

        cb(error, res);
    }
}

//get Similar posts
export const getSimilarPosts = (post) => async (dispatch) => {

    try {

        // dispatch({
        //     type: START_LOADING
        // });
    
        var query = post.tags.length > 0 ? { search: 'none', tags: post?.tags.join(',')} : { search: post.title, tags: ''};
        const {data: { data } } = await api.searchPosts(query);

        dispatch({
            type: FETCH_SIMILAR,
            payload: {
                post: post,
                similarPosts: data
            }
        });

        // dispatch({
        //     type: END_LOADING
        // });


    } catch (error) {

        console.log(error);
    }
}

//getPosts
export const getPosts = (page, append=false) => async (dispatch) => {

    try {

        dispatch({
            type: START_LOADING
        });

        const { data } = await api.fetchPosts(page);

        const actionType = append === true ? FETCH_MORE : FETCH_ALL; 

        dispatch({
            type: actionType,
            payload: data
        });

        dispatch({
            type: END_LOADING
        });

    }catch (error) {

        console.log(error);
    }

    
}


//getPost
export const getPost = (id, cb) => async (dispatch) => {

    let error = null; 
    let res = null;

    try {

        dispatch({
            type: START_LOADING
        });

        const { data } = await api.fetchPost(id);
        let post = {...data, similarPosts: []}; 

        dispatch({
            type: FETCH_POST,
            payload: post
        });

        dispatch({
            type: END_LOADING
        });

        res = post; 

    }catch (err) {

        console.log(err);

        error = err;
    }

    if(typeof cb === 'function'){

        cb(error, res);
    }
}

//create post
export const createPost = (inputData) => async (dispatch) => {

    

    try {

        dispatch({
            type: START_LOADING
        });

        //sort input data -- create multipart form 
        const userId = inputData.creatorId;
        const formData = new FormData(); 

        if(inputData.selectedFile){
            for(const property in inputData){

                if(property === 'avColors'){
    
                    inputData[property] = JSON.stringify(inputData[property]);
                }
    
                formData.append(property, inputData[property]);
    
            }
        }  

        let requstFunc = inputData.selectedFile ? api.createMediaPost : api.createPost; 
        let requestData = inputData.selectedFile ? formData : inputData; 

        //make request here
        const { data } = await  requstFunc(userId, requestData);

        dispatch({
            type: CREATE,
            payload: data
        });

        dispatch({
            type: END_LOADING
        });

    }catch(error) {

        console.log(error);
    }

}

//updatePost
export const updatePost = (id, inputData) => async (dispatch) => {

    try {

        //make request here
        const { data } = await  api.updatePost(id, inputData);

        dispatch({
            type: UPDATE,
            payload: data
        });



    }catch(error) {

        console.log(error);
    }

}

//delete post
export const deletePost = (id) => async (dispatch) => {

    try {

        //make request here
        await  api.deletePost(id);

        dispatch({
            type: DELETE,
            payload: id
        });



    }catch(error) {

        console.log(error);
    }

}

//likePost
export const likePost = (id) => async (dispatch) => {

    try {

        //make request here
        const { data } = await  api.likePost(id);

        dispatch({
            type: UPDATE,
            payload: data
        });



    }catch(error) {

        console.log(error);
    }

}


//create comment
export const commentPost = (value, id, userId, cb) => async (dispatch) => {

    let error = null; 
    let res = null; 

    try {

        const {data} = await api.comment(value, id, userId);

        dispatch({ //purpose is to update post to reflect new comment count, not reflect actual comments, that's done by getComments
            type: COMMENT,
            payload: data
        });

        res = data; 

    }catch(err) {

        console.log(err);

        error = err; 
    }

    if(typeof cb === 'function'){
        cb(error, res);
    }

}

//get post comments
export const getComments = (id, page, cb) => async (dispatch) => {
    //naturally invoked when post changes

    let error = null; 
    let res = null; 

    try {

        const {data} = await api.getComments(id, page);

        // dispatch({
        //     type: COMMENT,
        //     payload: data
        // });

        res = data; 

    }catch(err) {

        console.log(err);

        error = err; 
    }

    if(typeof cb === 'function'){
        cb(error, res);
    }

}